import { render } from "./ChatBot.vue?vue&type=template&id=7f72430f&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"

import "./ChatBot.vue?vue&type=style&index=0&id=7f72430f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f72430f"],['__file',"src/Components/ChatBot/ChatBot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f72430f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f72430f', __exports__)) {
    api.reload('7f72430f', __exports__)
  }
  
  module.hot.accept("./ChatBot.vue?vue&type=template&id=7f72430f&scoped=true", () => {
    api.rerender('7f72430f', render)
  })

}


export default __exports__